<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <input
        :id="id"
        :type="type"
        class="form-control"
        :class="getClasses(size, success, error, icon)"
        :name="name"
        :value="value"
        :placeholder="placeholder"
        :isRequired="isRequired"
        :title="errorMessage"
        @input="onInput"
      />
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :key="errorText" :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Input",
    props: {
      size: {
        type: String,
        default: "default",
      },
      success: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: "",
      },
      iconDir: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      id: {
        type: String,
        default: "",
      },
      value: {
        type: [String, Number],
        default: "",
      },
      placeholder: {
        type: String,
        default: "Type here...",
      },
      type: {
        type: String,
        default: "text",
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      errorMessage: {
        type: String,
        default: "",
      }
    },
    emits: ["update:value"],
    methods: {
      onInput(e) {
        this.$emit('update:value', e.target.value)
      },
      getClasses: (size, success, error, icon) => {
        let sizeValue, isValidValue, gap;

        sizeValue = size ? `form-control-${size}` : null;

        if (error) {
          isValidValue = "is-invalid";
        } else if (success) {
          isValidValue = "is-valid";
        } else {
          isValidValue = "";
        }

        if (icon !== "") {
          gap = "ps-2";
        }

        return `${sizeValue} ${isValidValue} ${gap}`;
      },
      getIcon: (icon) => (icon ? icon : null),
      hasIcon: (icon) => (icon ? "input-group" : null),
    },
  };

</script>
